export const TAB_SELECT = 'Groups/tab-select';
export const ERROR_MESSAGE_SET = 'Groups/error-message-set';
export const VIEW_GROUP = 'Groups/view-group';
export const GROUP_SET = 'Groups/groups-set';
export const SHOW_SET = 'Groups/show-set';
export const SHOW_DELETE_SET = 'Groups/show-delete-set';
export const DELETE_GROUP = 'Groups/delete-group';
export const DELETE_FAV = 'Groups/delete-fav';
